<template>
  <div class="news-problem p-10">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" size="medium" @click.native="add">添加</el-button>
      </div>
      <div class="search-group">
        <el-input
          placeholder="标题关键词"
          v-model="searchFormData.keyword"
          @keypress.enter.native="search"
        />
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
      >
        <template v-slot:is_use="row">{{row.is_use ? '是' : '否'}}</template>
        <template v-slot:action="row">
          <el-button @click="edit(row)" type="text" size="mini">修改</el-button>
          <el-button @click="del(row)" type="text" class="el-button--danger" size="mini">删除</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog
      :title="`${defaultFormItem.id? '编辑' : '新增'}问题`"
      :visible.sync="dialogVisible"
      @close="close"
      width="600px"
    >
      <ly-form
        :defaultFormItem="defaultFormItem"
        :formConfig="formConfig"
        :formKeys="formKeys"
        class="problem-form"
        ref="lyFormProblem"
      ></ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Input } from 'element-ui';
import { frontInf } from '@/api';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { problemTable } from '@/utils/tableHeader';
import { problemFormItem } from '@/utils/formConfig';

export default {
  name: 'NewsProblem',
  components: {
    LyTable,
    LyForm,
    ElInput: Input,
    ElDialog: Dialog
  },
  data() {
    return {
      searchFormData: {
        keyword: ''
      },
      defaultFormItem: {},
      tableHeader: problemTable,
      getTableData: frontInf.getQuestion,
      formKeys: problemFormItem,
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      dialogVisible: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyFormProblem.getFormData();
      if (!valid) return;
      if (this.defaultFormItem.id) {
        // 修改
        const res = await frontInf.controlQuestion({
          id: this.defaultFormItem.id,
          params: data,
          methold: 'post'
        });
        if (res) {
          this.$message.success(res.msg || '修改成功！');
          this.dialogVisible = false;
          this.search();
        }
      } else {
        // 新增
        const res = await frontInf.createQuestion({
          params: data
        });
        if (res) {
          this.$message.success(res.msg || '新增成功！');
          this.dialogVisible = false;
          this.search();
        }
      }
    },
    add() {
      this.dialogVisible = true;
      this.defaultFormItem = {};
    },
    close() {
      if (this.$refs.lyFormProblem) this.$refs.lyFormProblem.resetFields();
    },
    edit(row) {
      this.dialogVisible = true;
      this.defaultFormItem = { ...row };
    },
    del(row) {
      this.$confirm('永久删除该条信息, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          frontInf
            .controlQuestion({
              id: row.id,
              methold: 'DELETE'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less">
.news-problem {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
.problem-form {
  .el-input__inner,
  .el-textarea__inner {
    width: 400px;
  }
}
</style>
